import { z } from 'zod';
import {
    CardPointeInquireResponseBodySchema,
    CardPointeNormalizedGatewayTransactionDetailsSchema,
} from './cardpointe-transaction-details.schemas';
import {
    CardPointeTransactionStatusOutcome,
    type CardPointeInquireByOrderIdResponseBody,
    type CardPointeNormalizedTransactionStatusLookupResult,
    type CardPointeTransactionStatusRequestDetails,
    type CardPointeTransactionStatusRequestPathParams,
    type CardPointeTransactionStatusResponseDetails,
} from '../../../types/ipg/cardpointe/cardpointe-transaction-status.types';

export const CardPointeTransactionStatusRequestPathParamsSchema: z.ZodType<CardPointeTransactionStatusRequestPathParams> =
    z.object({
        orderid: z.string().min(1),
        merchid: z.string().min(1),
        set: z.literal('1'),
    });

export const CardPointeTransactionStatusRequestDetailsSchema: z.ZodType<CardPointeTransactionStatusRequestDetails> =
    z.object({
        method: z.literal('GET'),
        pathTemplate: z.literal('/cardconnect/rest/inquireByOrderid/{orderid}/{merchid}/{set}'),
        pathParams: CardPointeTransactionStatusRequestPathParamsSchema,
    });

export const CardPointeInquireByOrderIdResponseBodySchema: z.ZodType<CardPointeInquireByOrderIdResponseBody> =
    CardPointeInquireResponseBodySchema;

export const CardPointeNormalizedTransactionStatusLookupResultSchema: z.ZodType<CardPointeNormalizedTransactionStatusLookupResult> =
    z.object({
        gateway_transaction_details: CardPointeNormalizedGatewayTransactionDetailsSchema,
    });

export const CardPointeTransactionStatusResponseDetailsSchema: z.ZodType<CardPointeTransactionStatusResponseDetails> =
    z.discriminatedUnion('outcome', [
        z.object({
            outcome: z.literal(CardPointeTransactionStatusOutcome.FOUND),
            httpStatus: z.literal(200),
            rawDetails: CardPointeInquireByOrderIdResponseBodySchema,
            normalizedDetails: CardPointeNormalizedGatewayTransactionDetailsSchema,
        }),
        z.object({
            outcome: z.literal(CardPointeTransactionStatusOutcome.MISSING),
            httpStatus: z.number().int().positive(),
            rawDetails: z.unknown(),
            message: z.string().min(1),
        }),
        z.object({
            outcome: z.literal(CardPointeTransactionStatusOutcome.MALFORMED_RESPONSE),
            httpStatus: z.number().int().positive(),
            rawDetails: z.unknown(),
            message: z.string().min(1),
        }),
    ]);
